import { createApp, h } from "vue";
import Chat from "./components/Chat";

const app = createApp({
    render: () => h(Chat, { initialMessages: window.messages ?? [] }),
});

app.mount("#chat");